import React, { useState } from "react";

export default function CollapsibleCard({ 
  title, 
  subtitle, 
  isActive, 
  onToggleActive, 
  children,
  defaultExpanded = false,
  showToggleBtn = true,
  titleSize = 15,
  isLoadingToggle = false // 🔥 1. NUEVA PROPIEDAD PARA EL LOADING
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div style={{ 
      backgroundColor: 'white', 
      borderRadius: '12px', 
      overflow: 'hidden', 
      border: isActive ? '2px solid #EAC024' : '1px solid #E5E7EB', 
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)', 
      marginBottom: '12px',
      transition: 'all 0.2s' 
    }}>
      {/* 🔥 2. ESTILO PARA QUE EL SPINNER GIRE */}
      <style>{`@keyframes spinCard { 100% { transform: rotate(360deg); } }`}</style>

      <div 
        onClick={() => setIsExpanded(!isExpanded)} 
        style={{ 
          padding: '12px 16px', 
          cursor: 'pointer', 
          backgroundColor: isActive ? '#FFFBEB' : '#FFFFFF', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}
      >
        <div>
            <h4 style={{margin:0, fontSize: titleSize, color:'#1F2937', fontWeight:700}}>{title}</h4>
            <p style={{margin:'4px 0 0 0', fontSize:11, color: isActive ? '#D97706' : '#9CA3AF', fontWeight:600}}>{subtitle}</p>
        </div>
        
        <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
          
          {showToggleBtn && (
              <div 
                onClick={(e) => { 
                    e.stopPropagation(); 
                    if(isLoadingToggle) return; // 🔥 3. SI ESTÁ CARGANDO, IGNORA EL CLIC
                    if(onToggleActive) onToggleActive(); 
                }} 
                style={{ 
                  width: 24, height: 24, borderRadius: '50%', 
                  backgroundColor: isActive && !isLoadingToggle ? '#EAC024' : 'transparent', 
                  border: isActive && !isLoadingToggle ? 'none' : '2px solid #E5E7EB', 
                  display: 'flex', alignItems: 'center', justifyContent: 'center', 
                  color: 'white', fontSize: 12, 
                  cursor: isLoadingToggle ? 'wait' : 'pointer', // Cambia el cursor del mouse
                  transition: 'background-color 0.2s',
                  opacity: isLoadingToggle ? 0.6 : 1
                }}
              >
                 {/* 🔥 4. SI CARGA MUESTRA SPINNER, SINO MUESTRA EL CHECK */}
                 {isLoadingToggle ? (
                     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ animation: "spinCard 1s linear infinite" }}>
                         <circle cx="12" cy="12" r="10" stroke={isActive ? "#EAC024" : "#9CA3AF"} strokeWidth="4" opacity="0.3"></circle>
                         <path d="M12 2a10 10 0 0 1 10 10" stroke={isActive ? "#EAC024" : "#9CA3AF"} strokeWidth="4" strokeLinecap="round"></path>
                     </svg>
                 ) : (
                     isActive && "✓"
                 )}
              </div>
          )}

          <span style={{ fontSize: 10, color: '#9CA3AF', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
        </div>
      </div>

      {isExpanded && (
        <div style={{
            borderTop: isActive ? '1px solid #EAC024' : '1px solid #E5E7EB', 
            padding:'8px 16px', 
            backgroundColor:'#FAFAFA'
        }}>
            {children}
        </div>
      )}
    </div>
  );
}